import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'; // Add ReactiveFormsModule
import { HeaderComponent } from '../../header/header.component';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { SuperadminService } from 'src/app/services/superadmin.service';

@Component({
  selector: 'app-superadmin-login',
  standalone: true,
  imports: [CommonModule, HeaderComponent, ReactiveFormsModule], // Add ReactiveFormsModule here
  templateUrl: './superadmin-login.component.html',
  styleUrls: ['./superadmin-login.component.scss']
})
export class SuperadminLoginComponent implements OnInit {
  signupForm: FormGroup;
  loginForm: FormGroup;
  setPassword: boolean = false; // Toggle between login and register forms
  errorLabel: string = '';

  constructor(
    private superadminService: SuperadminService,
    private formBuilder: FormBuilder,
    private route: Router,
    private localStorageService: LocalstorageService
  ) {
    // Login Form
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    // Register Form
    this.signupForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    // Check if the user is already logged in
    const currentUser = this.localStorageService.getEmployeeDetails();
    if (currentUser.email) {
      this.loginForm.get('email')?.setValue(currentUser.email);
    }
  }

  // Toggle to Register Form
  enableRegister(event: Event) {
    event.preventDefault();
    this.setPassword = true;
  }

  // Toggle to Login Form
  enableLogin(event: Event) {
    event.preventDefault();
    this.setPassword = false;
  }

  // Toggle Password Visibility
  togglePassword(elementName: string) {
    const passwordInput = document.getElementById(elementName) as HTMLInputElement;
    if (passwordInput) {
      passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
    }
  }

  // Validate Login
  validateLogin() {
    const loginDetails = {
      email: this.loginForm.get('email')?.value,
      password: this.loginForm.get('password')?.value
    };

    this.superadminService.loginSuperadminWithExisting(loginDetails).subscribe(
      (res: any) => {
        this.localStorageService.setEmailInLocalStorage(loginDetails.email);
        this.route.navigate(['/superadmin-dashboard']);
      },
      (error: any) => {
        this.errorLabel = 'Incorrect email or password';
      }
    );
  }

  // Register New Super Admin
  signupUser() {
    const signUpDetails = {
      email: this.signupForm.get('email')?.value,
      password: this.signupForm.get('password')?.value
    };

    this.superadminService.signUpAsSuperadmin(signUpDetails).subscribe(
      (res: any) => {
        this.localStorageService.setEmailInLocalStorage(signUpDetails.email);
        this.route.navigate(['/superadmin-dashboard']);
      },
      (error: any) => {
        this.errorLabel = 'Registration failed. Please try again.';
      }
    );
  }
}